import React from 'react';
import { SIZE } from '../../../components/Helper/Constant';
import { Spin } from 'antd';

const LoadingContainer = () => {
    return (
        <div className='container ns-flex_center'>
            <Spin size={SIZE.LARGE} />
        </div>
    );
};

export default LoadingContainer;
